import React, { useMemo } from 'react';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
} from '../../../contextsProperty/ContextProperties';
import Card from '../../../../muiComponents/Card';
import Tag from '../../../../muiComponents/Tag';
import { getRandomNumber } from '../../../../utils/usefulFunctions';
import LoadingTab from '../LoadingTab';
import Title from '../Title';

const MealPlans = () => {
    const { name, mealPlanTypes, toggleItemInCollection } = useProperty();
    const { mealPlanTypesList } = usePropertyComplementaryData();

    const { isFetching } = usePropertyFetching();

    const visibleMealPlans = useMemo(() => {
        return mealPlanTypes.filter(mealPlan => !mealPlan.Deleted);
    }, [mealPlanTypes]);

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'meal_plans_section'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <div className='flex flex-center flex-wrap gap-20'>
                    {mealPlanTypesList.map(option => {
                        const targetMealPlan = visibleMealPlans.find(
                            mealPlan => mealPlan.idType === parseInt(option.id)
                        );

                        const isChecked = !!targetMealPlan;
                        return (
                            <Tag
                                button
                                onClick={() => {
                                    const newMaelPlan = targetMealPlan || {
                                        id: `-${getRandomNumber(0, 999)}`,
                                        name: `Mealplan ${option.mappingCodeTemplate} for ${name}`,
                                        mappingCode: option.mappingCodeTemplate,
                                        idType: parseInt(option.id),
                                        typeName: option.name,
                                        typeMappingCodeTemplate:
                                            option.mappingCodeTemplate,
                                    };

                                    toggleItemInCollection(
                                        'mealPlanTypes',
                                        newMaelPlan
                                    );
                                }}
                                key={option.id}
                                size='large'
                                color='purple'
                                variant={isChecked ? 'contrast' : 'surface'}
                                text={option.name}
                            />
                        );
                    })}
                </div>
            </Card>
        </div>
    );
};

export default MealPlans;
